// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Bigger":"Button_Bigger__31IX7","Active":"Button_Active__qztro"};